import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoArrowBackOutline } from "react-icons/io5";
import apiClient from "../api/apiClient";
import "../css/Charts.css";
import "../css/mainhome.css";

export default function ChartDetail() {
  const { gameId, chartName } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!gameId) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await apiClient.post("/table-chart", {
          gameId: parseInt(gameId, 10),
          gameType: "game",
        });

        if (res.data?.status && Array.isArray(res.data.info)) {
          setData(res.data.info);
        } else {
          setData([]);
          setError(res.data?.msg || "Failed to fetch chart data.");
        }
      } catch (err) {
        console.error("Chart detail fetch error:", err);
        setError("Failed to fetch chart data.");
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [gameId]);

  const decodedTitle = chartName
    ? chartName.replace(/-/g, " ").toUpperCase()
    : "CHART";

  return (
    <div className="mainhome-screen-wrapper">
      <div className="charts-header screen-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <IoArrowBackOutline size={24} />
        </button>

        <h2>{decodedTitle}</h2>
      </div>

      <div className="chart-table-container screen-content">
        <div className="chart-table-header">
          <span>Date</span>
          <span>Open</span>
          <span>Jodi</span>
          <span>Close</span>
        </div>

        {loading && (
          <p className="chart-message">Loading chart...</p>
        )}

        {!loading && error && (
          <p className="chart-message error">{error}</p>
        )}

        {!loading && !error && data.length === 0 && (
          <p className="chart-message">No chart data available.</p>
        )}

        <div className="chart-table-body">
          {!loading &&
            !error &&
            data.map((row, idx) => (
              <div key={idx} className="chart-row">
                <span>{row.date}</span>
                <span>{row.open}</span>
                <span className="jodi">{row.digit}</span>
                <span>{row.close}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}